import { createSlice } from '@reduxjs/toolkit'
import {
  getAllData,
  getData,
  getUser,
  selectUser,
  usersAutocomplete,
  addUserRequest,
  addVehicle
} from './thunk'

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    vehicles: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedVehicle: {},
    vehicleResponse: null,
    isAddUser: false,
    showUserList: false,
    showVehiclesList: false,
    updateModal: false
  },
  reducers: {
    addUser: (state, action) => {
      state.isAddUser = action.payload
    },
    showUser: (state, action) => {
      state.showUserList = action.payload
    },
    showVehicle: (state, action) => {
      state.showVehiclesList = action.payload
    },
    setUser: (state, action) => {
      state.selectedUser = action.payload.data
      state.showVehiclesList = action.payload.flag
    },
    setUpdateModal: (state, action) => {
      state.updateModal = action.payload
    },
    setVehicle: (state, action) => {
      state.selectedVehicle = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUserRequest.fulfilled, (state, action) => {
        state.selectedUser = action.payload.data
        state.data = action.payload.list
        state.showUserList = action.payload.flag
      })
      .addCase(addVehicle.fulfilled, (state, action) => {
        state.selectedUser = action.payload.data
        state.isAddUser = action.payload.flag
        state.showVehiclesList = true
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(selectUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(usersAutocomplete.fulfilled, (state, action) => {
        state.data = action.payload
      })
  }
})

export const {
  addUser,
  showUser,
  showVehicle,
  setUser,
  setUpdateModal,
  setVehicle
} = appUsersSlice.actions

export const usersList = appUsersSlice.reducer
